var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"hide-top":"","hide-side":""}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('not-found',{attrs:{"header":_vm.header,"body":_vm.body}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }